import trimmedEndIndex from './_trimmedEndIndex.js';

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

export default baseTrim;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_baseTrim.js
// module id = 8469
// module chunks = 2